import { ChainId } from '../config/constants/chainId'
import getCollections, { Collection } from '../config/constants/nftCollections'

export default function useCollection(chainId?: ChainId, collectionId?: string): Collection | undefined {
  const nftCollections = getCollections()
  return chainId ? nftCollections[chainId].find((coll) => coll.address === collectionId) : undefined
}
